var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfile = function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.535 14.705C10.373 15.369 8 18.138 8 21.449c0 .346.285.628.636.628h12.728c.252 0 .47-.145.573-.356l.043-.115.017-.093.003-.064c0-3.311-2.374-6.08-5.535-6.744 1.51-.579 2.582-2.026 2.582-3.718C19.047 8.787 17.235 7 15 7s-4.047 1.787-4.047 3.987c0 1.692 1.072 3.14 2.582 3.718Z",
    fill: "#1D352A",
    fillOpacity: 0.5
  })));
};
export default SvgProfile;